import type { TaskInstance } from './task-instance.interface';

export interface TaskTopLine {
    C_Line_key: number;
    C_TaskInstance_key: number;
    LineName: string;
    TaskInstance: TaskInstance;
}
